import React, { useEffect, useState } from 'react';
import { Overlays } from '../overlays';
import FormationPlayerCard from '../formationPlayerCard';
import TeamDetail from '../teamDetail';
import PlayerInfoStats from '../playerInfoStats';
import Typo from '../typo';
import Accordion from '../Accordion';
import AccordionChild from '../Accordion/accordionChild';
import Fixture from '../fixture';
import MatchCardDate from '../matchCardDate';
import NoDataFound from '../noDataFound';
import { useDispatch, useSelector } from 'react-redux';
import {
  setClassName,
  setPlayerInfoOverlay,
  setShowPlayerSectionCTA
} from 'store/slice/overlaySlice';
import { useGetPlayerCardsFixtureQuery, useGetPlayerCardsStatsQuery } from 'api';
import Loader from '../loader';
import { IMG_BASE_PATH } from 'utils/constants';
import { formatDate } from 'utils/commonFunctions';
import { playerSelection } from 'store/slice/createTeamSlice';
import { useMatch } from 'react-router-dom';

const PlayerCardOverlay = ({}) => {
  const match = useMatch('/createteam');
  const dispatch = useDispatch();
  const playerCard = useSelector((state) => state.overlay.playerCard);
  const [activeIndex, setActiveIndex] = useState(null);
  const [gamedayId, setDamedayId] = useState(null);
  const selectedPlayers = useSelector((state) => state?.createTeam?.selectedPlayers || []);
  const disableClassName = useSelector((state) => state?.overlay?.disableClassName);
  const showPlayerSectionCTA = useSelector((state) => state?.overlay?.showPlayerSectionCTA);

  const {
    data: cardFixtures,
    isError: fixtureError,
    isLoading: fixtureLoading
  } = useGetPlayerCardsFixtureQuery(
    { playerId: playerCard?.id },
    { refetchOnMountOrArgChange: true, skip: !playerCard?.id }
  );
  const {
    data: cardStats,
    isError: statsError,
    isLoading: statsLoading
  } = useGetPlayerCardsStatsQuery(
    { playerId: playerCard?.id, gamedayId: gamedayId },
    { refetchOnMountOrArgChange: true, skip: !playerCard?.id || !gamedayId }
  );

  const updateActiveIndex = (index, value) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    setDamedayId(value);
  };

  const totalGdPts =
    cardFixtures?.Data?.Value?.Completed?.reduce((sum, item) => sum + (item.gd_pts || 0), 0) || 0;
  const count = cardFixtures?.Data?.Value?.Completed?.length || 0;
  const avgGdPts = count > 0 ? (totalGdPts / count).toFixed(1) : '-';

  useEffect(() => {
    return () => {
      dispatch(setClassName(false));
      dispatch(setShowPlayerSectionCTA(true));
    };
  }, []);

  if (fixtureError || fixtureLoading) {
    return <Loader />;
  }

  const reversedCardFixtures = cardFixtures?.Data?.Value?.Completed ? [...cardFixtures?.Data?.Value?.Completed].reverse() : [];


  return (
    <>
      <Overlays
        overlayName='playerDetails'
        overlayConfig={{
          noOverlayHead: true,
          noOverlayFoot: true,
          noOverlayClose: true,
          isDisabled: disableClassName,
          submitBtn:
            !selectedPlayers.some((player) => player.id === playerCard?.id) &&
            match &&
            showPlayerSectionCTA,
          cancelBtn:
            selectedPlayers.some((player) => player.id === playerCard?.id) &&
            match &&
            showPlayerSectionCTA,
          title: 'PLAYER DETAILS',
          titleTransKey: 'overlay_title_player_details',
          btnPrimary: 'Add Player',
          btnSecondary: 'Remove Player',
          btnPrimaryTransKey: 'cta_add_player',
          onCancelClick: () => {
            dispatch(playerSelection({ ply: playerCard }));
            dispatch(setPlayerInfoOverlay(false));
          },
          onClickProp: () => {
            dispatch(setPlayerInfoOverlay(false));
          },
          onConfirmClick: () => {
            dispatch(playerSelection({ ply: playerCard }));
            dispatch(setPlayerInfoOverlay(false));
          }
        }}
      >
        <div className='si-popup__content'>
          <div className='si-playerInfo__head'>
            <div className={`playerCard`}>
              {/* <div className={`playerCard ${playerType ? `si--${playerType}` : ''}`}> */}
              <div className='playerCard-lhs'>
                <FormationPlayerCard
                  // plyrName={playerCard?.name}
                  thumbnail={playerCard?.id}
                  fallback={`${IMG_BASE_PATH}images/players/2.png`}
                />
              </div>
              <div className='playerCard-rhs'>
                <FormationPlayerCard plyrName={playerCard?.name} />
                <TeamDetail teamFlag={playerCard?.team_id} teamName={playerCard?.team_name} />
              </div>
            </div>
          </div>
          <div className='si-playerInfo__stats-row'>
            <PlayerInfoStats title='Avg Points' data={avgGdPts} />
            <PlayerInfoStats
              title='Matches played'
              data={
                cardFixtures?.Data?.Value?.Completed?.length
                  ? cardFixtures?.Data?.Value?.Completed?.length
                  : '-'
              }
            />
          </div>
          <div className='si-playerInfo__body'>
            {/* <div className='si-playerInfo__stats-row'>
              <PlayerInfoStats title='Avg Points' data={avgGdPts} />
              <PlayerInfoStats
                title='Matches played'
                data={
                  cardFixtures?.Data?.Value?.Completed?.length
                    ? cardFixtures?.Data?.Value?.Completed?.length
                    : '-'
                }
              />
            </div> */}

            <Typo
              transKey={'player_details_performance_title'}
              component='h5'
              className='si-playerInfo__performance'
            >
              PERFORMANCE
            </Typo>
          </div>
          <div className='si-playerInfo__accordion'>
            {reversedCardFixtures?.length ? (
              reversedCardFixtures?.map((card, index) => {
                return (
                  <Accordion
                    key={index}
                    data={reversedCardFixtures}
                    activeIndex={activeIndex}
                    accordionChild={
                      <>
                        <AccordionChild
                          isActive={activeIndex === index}
                          updateActiveIndex={updateActiveIndex}
                          gameday_id={card?.gameday_id}
                          accordionHead={
                            <>
                              <div className='si-playerInfo__accordion-row'>
                                <div className='si-playerInfo__fixture'>
                                  <Fixture
                                    match={{
                                      teamA: {
                                        id: card?.home_team_id /* name: card?.home_team_name  */
                                      },
                                      teamB: {
                                        id: card?.away_team_id /*  name: card?.away_team_name */
                                      }
                                    }}
                                  />
                                </div>
                                <MatchCardDate matchdate={formatDate(card?.match_date)} />
                              </div>
                              <div className='si-playerInfo__stats-row'>
                                <PlayerInfoStats
                                  title='Picked By %'
                                  data={
                                    typeof card?.sel_per === 'number' ? `${card?.sel_per}%` : '-'
                                  }
                                />
                                <PlayerInfoStats
                                  title='Match Points'
                                  data={typeof card?.gd_pts === 'number' ? card?.gd_pts : '-'}
                                />
                              </div>
                              {/* <div className='si-accordion__icon'>
                                    <Typo component='span' className='lms-chevron-down'></Typo>
                                  </div> */}
                            </>
                          }
                          bodyComponent={
                            cardFixtures?.Data?.Value?.Completed?.length ? (
                              // <PlayerLists />
                              <div className='si-tbl'>
                                <div className='si-tbl__head'>
                                  <div className='si-tbl__row'>
                                    <Typo
                                      transKey={'table_heading_events'}
                                      component='div'
                                      className='si-tbl__cell si-tbl__cell--events'
                                    >
                                    </Typo>
                                    <Typo
                                      transKey={'leaderboard_points'}
                                      component='div'
                                      className='si-tbl__cell si-tbl__cell--count'
                                    >
                                    </Typo>
                                  </div>
                                </div>
                                <div className='si-tbl__body'>
                                  {cardStats?.Data?.Value?.fixtures?.map((fixture, index) => {
                                    const { stats } = fixture;
                                    return stats?.map((stat, index) => {
                                      return (
                                        <div className='si-tbl__row ' key={index}>
                                          <Typo
                                            transKey={''}
                                            component='div'
                                            className='si-tbl__cell si-tbl__cell--events'
                                          >
                                            {stat?.name}
                                          </Typo>
                                          <Typo
                                            transKey={''}
                                            component='div'
                                            className='si-tbl__cell si-tbl__cell--count'
                                          >
                                            {stat?.points}
                                          </Typo>
                                        </div>
                                      );
                                    });
                                  })}
                                </div>
                              </div>
                            ) : (
                              <NoDataFound
                                noDataCaption={window?.['translations']?.['no_data_available'] ||'No data available.'}
                                // noDataCaption={trans['classic_playercard_perform_will_displayed']}
                              />
                            )
                          }
                          accordionConfig={{}}
                          index={index}
                        />
                      </>
                    }
                  />
                );
              })
            ) : (
              <NoDataFound noDataCaption='Data will be available once the player start scoring.' />
            )}
          </div>
        </div>
      </Overlays>
    </>
  );
};

export default PlayerCardOverlay;
